<!-- 云果简介 -->
<template>
<div class="info-block">
  <div class="info-detail-content">
<!--    <p>-->
<!--      中国牛油果交易中心：牛油果交易中心是由孟连县农商品供应链有限公司、普洱绿银生物股份有限公司、云南唯恒果业有限公司三方共同联手建设。在统一的牛油果商品果标准基建上，建立平台化多元交易方式，统一线上线下交易标准、统一结算流程，建立数字化的利益联结机制，形成牛油果交易聚散中心；整合产区优势，建设牛油果价格形成中心，负责牛油果市场价格发现，跨产区销售价格指导，发布国产牛油果价格指数。力求将其打造成为国内最大的国产牛油果原产地供应链中心、交易结算中心。-->
<!--    </p>-->
    <p style="text-indent: 0; ">
      牛油果网是一个专注于牛油果产业的综合性服务平台，致力于为产业从业者、消费者、关注牛油果产业的相关人士，提供新闻资讯、产业政策、价格行情、供求信息等内容，同时还为产业从业者提供全方位的产业服务支持，促进产业可持续发展。
    </p>
    <p style="text-indent: 0; ">
      中国孟连牛油果集配中心是牛油果网体系下的一个重要组成部分，本中心是由孟连县产业投资集团有限公司、普洱绿银生物股份有限公司、云南唯恒果业有限公司，三方共同联手建设的，以孟连为核心，聚合采收、分选、仓储、包装、物流、交易等关键要素及服务，提高产地供应链能力、品质控制及物流效率的牛油果产业链核心工程。
    </p>
  </div>
</div>
</template>
<script>
export default {
  name: 'YgjjInfo',
  props: {
    info: {
      type: Object,
      default: function () { return {} }
    }
  },
  data () {
    return {

    }
  },
  created: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:280px;
  padding:0px;
  margin:0px 0px 10px 0px;
  //background-color:green;
}

.info-block .info-block-a:hover{
  border:1px solid orange;
  box-shadow:0px 0px 1px 1px orange;
}

.info-detail-content{
  position:relative;
  margin-top:20px;
  background-color:#eee;
  border-radius:2px;
  background-color:rgba(255,255,255,0.6);
}

.info-detail-content p{
  padding:10px;
  font-size:14px;
  font-weight:0;
  text-align: justify;
  text-indent:2em;
  line-height:40px;
  letter-spacing:0px;
  font-family: Arial,"PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;
  color:#333;
}
</style>



// WEBPACK FOOTER //
// src/components/module/YgjjInfo.vue